// extracted by mini-css-extract-plugin
export default {"container":"Hca-z","oos":"Ica-z","oosUx":"Jca-z","selected":"Kca-z","labelOos":"Lca-z"};